import {
  Identifiable,
  Planzone,
  ProjectElementDetailsConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(): ProjectElementDetailsConfiguration {
  return [
    {
      name: "Default",
      roles: [
        "pz_admin",
        "pz_under_admin",
        "pz_user",
        "pz_visitor",
        "pr_visitor",
        "pr_manager",
        "pr_worker",
      ],
      columns: [],
    },
  ];
}

function getProjectElementDetailsConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) =>
        !!data.projectElementDetailsConfiguration
          ? JSON.parse(data.projectElementDetailsConfiguration)
          : getDefaultConf(),
      );
}

export { getProjectElementDetailsConfiguration };
